import { useEffect } from 'react';
import { BookingProvider } from '../contextApi/BookingContext';
import useTranslation from '../customHooks/useTranslation';
import Header from '../components/sheet/Header';
import Hero from '../components/sheet/Hero';
import Cooperation from '../components/sheet/Cooperation';
import Scope from '../components/sheet/Scope';
import Stack from '../components/sheet/Stack';
import About from '../components/sheet/About';
import Contact from '../components/sheet/Contact';
import Footer from '../components/sheet/Footer';
import SheetFrame from '../components/sheet/SheetFrame';

function MainPage() {
	const t = useTranslation();

	useEffect(() => {
		document.title = t.meta.title;
		document.querySelector('meta[name="description"]')?.setAttribute('content', t.meta.description);
	}, [t]);

	return (
		<BookingProvider>
			<SheetFrame />
			<Header />
			<main className='overflow-x-clip'>
				<Hero />
				<Cooperation />
				<Scope />
				<Stack />
				<About />
				<Contact />
			</main>
			<Footer />
		</BookingProvider>
	);
}

export default MainPage;
